/* The filter row and table footer, shared by the Contacts and Clients tables.
   mockups/crm-v3-contacts-v1.html, sections #a and #clients. */
import { chip } from "../../lib/styles.js";
import { S, ROW_HOVER_CSS } from "./listStyles.js";
import { showingText, pageNumbers } from "./listModel.js";

/** The row hover tint, as a stylesheet rather than a piece of React state.
 *  See the note above ROW_HOVER_CSS in listStyles.js. */
export function ListRowStyle() {
  return <style>{ROW_HOVER_CSS}</style>;
}

/** The lettered chips on the left of the filter row. */
export function Chips({ options, value, onChange, testid }) {
  return options.map((o) => (
    <span
      key={o.key}
      role="button"
      tabIndex={0}
      aria-pressed={value === o.key}
      data-testid={testid ? `${testid}-${o.key}` : undefined}
      style={chip(value === o.key)}
      onClick={() => onChange(o.key)}
      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onChange(o.key); } }}
    >
      {o.label}
    </span>
  ));
}

/** A labelled dropdown, drawn as one pill: "Consent  Any ▾". */
export function SelectPill({ label, value, options, onChange, testid }) {
  return (
    <span style={S.selWrap}>
      <span style={S.selLabel}>{label}</span>
      <select
        aria-label={label}
        data-testid={testid}
        style={S.select}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((o) => <option key={o.key} value={o.key}>{o.label}</option>)}
      </select>
    </span>
  );
}

/**
 * "Showing 1 to 40 of 3,412 · Sorted by last touch · 1 2 3 … 86".
 *
 * Only the visible page is rendered above this; the page numbers move the
 * window, they do not re-filter anything.
 */
export function TableFooter({ page, noun, sortLabel, onPage }) {
  return (
    <div style={S.foot}>
      <span data-testid={`${noun}-showing`}>{showingText(page, noun)}</span>
      {sortLabel && <span>Sorted by {sortLabel.toLowerCase()}</span>}
      {page.pages > 1 && (
        <span style={S.pager}>
          {pageNumbers(page.page, page.pages).map((n, i) => (
            n === "…"
              ? <span key={`gap-${i}`} style={S.pageGap}>…</span>
              : (
                <button
                  key={n}
                  type="button"
                  aria-current={n === page.page ? "page" : undefined}
                  style={n === page.page ? { ...S.page, ...S.pageOn } : S.page}
                  onClick={() => onPage(n)}
                >
                  {n}
                </button>
              )
          ))}
        </span>
      )}
    </div>
  );
}
